import React, { lazy } from 'react';
import { ShieldCheckIcon, ZapIcon, FlameIcon, CheckIcon, RocketIcon, ArrowRightIcon, LockIcon, RefreshCwIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { useGeoPricingContext } from '../hooks/GeoPricingContext';
import { useViewerCount } from '../hooks/useViewerCount';
export function PurchaseSection() {
  const {
    minutes,
    seconds
  } = useCountdown(900);
  const {
    oldPrice,
    newPrice
  } = useGeoPricingContext();
  const viewerCount = useViewerCount(98);
  return <section id="comprar" className="bg-cream py-10 px-4" data-id="element-361">
      <div className="max-w-[500px] mx-auto" data-id="element-362">
        {/* Offer Box */}
        <div className="bg-brand-black-light rounded-xl p-6 mx-auto border-2 border-primary shadow-gold animate-subtle-glow" data-id="element-363">
          <div className="text-center mb-2 text-dark-gray text-sm uppercase tracking-wider font-semibold" data-id="element-364">
            PRECIO DE OFERTA
          </div>
          <div className="flex flex-col items-center gap-1 leading-none text-center" data-id="element-365">
            <span className="text-xl line-through text-dark-gray font-bold" data-id="element-366">
              {oldPrice}
            </span>
            <div className="text-primary font-bold mt-2 mb-1 flex items-center justify-center gap-2" data-id="element-367">
              <FlameIcon className="w-6 h-6" data-id="element-368" /> PRECIO DE LANZAMIENTO:
            </div>
            <span className="text-[64px] font-black text-brand-black font-poppins tracking-tight leading-none" data-id="element-369">
              {newPrice}
            </span>
          </div>
          <div className="text-center mt-4 text-sm text-dark-gray" data-id="element-370">
            Pago único · Sin suscripciones · Sin cargos ocultos
          </div>
          <div className="flex justify-around mt-5 pt-5 border-t border-white/10 text-dark-gray text-xs font-semibold" data-id="element-371">
            <div className="flex items-center gap-1.5" data-id="element-372">
              <ShieldCheckIcon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-373" />
              Compra Segura
            </div>
            <div className="flex items-center gap-1.5" data-id="element-374">
              <ZapIcon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-375" />
              Acceso Instantáneo
            </div>
          </div>
        </div>

        {/* CTA */}
        <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 mx-auto mt-8 bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-376">
          QUIERO ACCESO INMEDIATO
          <ArrowRightIcon className="w-5 h-5" data-id="element-377" />
        </a>

        {/* Trust Section */}
        <div className="mt-6 mx-auto max-w-[440px]" data-id="element-378">
          {/* Seller Reputation */}
          <div className="bg-brand-black-light border border-primary/30 rounded-xl p-4" data-id="element-379">
            <div className="flex items-center gap-2 mb-2" data-id="element-380">
              <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-381" />
              <span className="text-primary font-bold text-sm" data-id="element-382">
                Vendedor Verificado
              </span>
              <span className="text-dark-gray text-xs" data-id="element-383">
                · ¡Uno de los mejores!
              </span>
            </div>
            {/* Progress bar */}
            <div className="flex gap-0.5 mb-3 rounded-full overflow-hidden h-1.5" data-id="element-384">
              <div className="bg-red-400/60 flex-1" data-id="element-385"></div>
              <div className="bg-orange-400/60 flex-1" data-id="element-386"></div>
              <div className="bg-yellow-400/60 flex-1" data-id="element-387"></div>
              <div className="bg-lime-400/60 flex-1" data-id="element-388"></div>
              <div className="bg-emerald-500 flex-[2]" data-id="element-389"></div>
            </div>
            <div className="flex items-center justify-between text-xs text-dark-gray" data-id="element-390">
              <div className="text-center" data-id="element-391">
                <div className="text-brand-black font-black text-base" data-id="element-392">
                  +10mil
                </div>
                <div data-id="element-393">Ventas</div>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-394"></div>
              <div className="text-center flex flex-col items-center" data-id="element-395">
                <CheckCircleIcon className="w-4 h-4 text-success mb-0.5" data-id="element-396" />
                <div data-id="element-397">Buena atención</div>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-398"></div>
              <div className="text-center flex flex-col items-center" data-id="element-399">
                <CheckCircleIcon className="w-4 h-4 text-success mb-0.5" data-id="element-400" />
                <div data-id="element-401">Entrega a tiempo</div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-col items-center gap-2 mt-5 text-sm text-dark-gray font-medium" data-id="element-402">
          <div className="flex items-center gap-3" data-id="element-403">
            <span className="flex items-center gap-1" data-id="element-404">
              <LockIcon className="w-4 h-4 text-primary" data-id="element-405" /> Garantía 7 Días
            </span>
            <span data-id="element-406">·</span>
            <span className="flex items-center gap-1" data-id="element-407">
              <ZapIcon className="w-4 h-4 text-primary" data-id="element-408" /> Acceso Inmediato
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-409">
            <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-410" /> Actualizaciones
            diarias de por vida
          </div>
          <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-411">
            <div className="flex text-primary" data-id="element-412">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-413" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-414" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-415" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-416" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-417" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-418">
              4.9/5{' '}
              <span className="text-dark-gray font-normal" data-id="element-419">
                +12.500 Electricistas
              </span>
            </span>
            <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-420" />
          </div>
        </div>

        {/* Urgency Warning */}
        <div className="bg-red-900/40 border-2 border-red-500 rounded-xl p-5 mt-8 text-center shadow-[0_0_20px_rgba(239,68,68,0.3)]" data-id="element-421">
          <h3 className="text-red-500 text-[22px] font-black mb-2 flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-422">
            <FlameIcon className="w-6 h-6" aria-hidden="true" data-id="element-423" />
            OFERTA SOLO POR HOY
          </h3>
          <p className="text-sm text-white font-medium leading-[1.4] mb-4" data-id="element-424">
            Reserva válida por tiempo limitado. Si sales, el precio puede subir.
          </p>
          <div className="flex justify-center gap-2.5 text-center" data-id="element-425">
            <div className="bg-red-950 py-2.5 px-4 rounded-lg min-w-[60px] border border-red-500/50 shadow-sm" data-id="element-426">
              <div className="text-[28px] font-bold text-white leading-none" data-id="element-427">
                {minutes}
              </div>
              <div className="text-[10px] uppercase text-red-200 mt-1.5 tracking-wider font-bold" data-id="element-428">
                Min
              </div>
            </div>
            <div className="bg-red-950 py-2.5 px-4 rounded-lg min-w-[60px] border border-red-500/50 shadow-sm" data-id="element-429">
              <div className="text-[28px] font-bold text-white leading-none" data-id="element-430">
                {seconds}
              </div>
              <div className="text-[10px] uppercase text-red-200 mt-1.5 tracking-wider font-bold" data-id="element-431">
                Seg
              </div>
            </div>
          </div>
        </div>

        {/* Urgency Badges */}
        <div className="max-w-[500px] mx-auto mt-6 flex flex-col gap-3" data-id="element-432">
          <div className="bg-brand-black-light border border-white/10 text-brand-black font-bold py-3 px-4 rounded-lg text-sm text-center shadow-sm flex items-center justify-center gap-3" data-id="element-433">
            <span className="inline-flex items-center gap-1.5 bg-red-600 text-white text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full animate-pulse" data-id="element-434">
              <span className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-435"></span>
              EN VIVO
            </span>
            <span data-id="element-436">
              <strong data-id="element-437">
                <span className="text-primary" data-id="element-438">{viewerCount}</span> personas
              </strong>{' '}
              están viendo esta oferta
            </span>
          </div>
        </div>
      </div>
    </section>;
}